// components/ProgressRing.jsx
const ProgressRing = ({ progress }) => (
  <div className="relative w-10 h-10">
    <svg className="w-10 h-10 -rotate-90">
      <circle
        cx="20"
        cy="20"
        r="16"
        stroke="#1f3b57"
        strokeWidth="3"
        fill="none"
      />
      <circle
        cx="20"
        cy="20"
        r="16"
        stroke="#00b8f1"
        strokeWidth="3"
        fill="none"
        strokeDasharray={2 * Math.PI * 16}
        strokeDashoffset={
          2 * Math.PI * 16 * (1 - progress / 100)
        }
        strokeLinecap="round"
      />
    </svg>

    <div className="absolute inset-0 flex items-center justify-center text-xs text-[#00b8f1] font-semibold">
      {progress}%
    </div>
  </div>
);

export default ProgressRing;